export const AppConfig = {
  app: {
    name: import.meta.env.VITE_APP_NAME || "Visor Inventarios",
    version: import.meta.env.VITE_APP_VERSION || "0.1.0",
    environment: import.meta.env.VITE_APP_ENV || "development",
  },

  api: {
    useMock: import.meta.env.VITE_USE_MOCK === "true",
    cacheEnabled: import.meta.env.VITE_API_CACHE_ENABLED === "true",
    isLocal: import.meta.env.VITE_API_LOCAL === "true",
    localUrl: import.meta.env.VITE_API_LOCAL_URL || "http://localhost:5074",
    baseUrl: import.meta.env.VITE_API_BASE_URL || "http://localhost:5074",
    timeout: Number.parseInt(import.meta.env.VITE_API_TIMEOUT) || 15000,
    retryAttempts: Number.parseInt(import.meta.env.VITE_API_RETRY_ATTEMPTS) || 3,
  },

  lcapii: {
    url: import.meta.env.VITE_LCAPII_URL || "https://lcapii.casadelaudio.com",
    sid: Number.parseInt(import.meta.env.VITE_LCAPII_SID) || 0,
    skipLogin: import.meta.env.VITE_LCAPII_SKIP_LOGIN === "true",
    // Ids de permiso del sistema en LCApii (mismos valores que LCApii:Permisos:Pid_* de la API)
    permisos: {
      ingresar: Number.parseInt(import.meta.env.VITE_LCAPII_PID_INGRESAR) || 0,
      eliminarInventario: Number.parseInt(import.meta.env.VITE_LCAPII_PID_ELIMINAR_INVENTARIO) || 0,
      eliminarMuestreo: Number.parseInt(import.meta.env.VITE_LCAPII_PID_ELIMINAR_MUESTREO) || 0,
      gestionarEquipos: Number.parseInt(import.meta.env.VITE_LCAPII_PID_GESTIONAR_EQUIPOS) || 0,
    },
  },

  features: {
    debug: import.meta.env.VITE_ENABLE_DEBUG === "true",
  },

  // URL base ya resuelta (local vs producción). Útil para armar links directos de descarga
  // (xls, csv, apk) que no pasan por ApiService.
  resolvedApiUrl: () => (AppConfig.api.isLocal ? AppConfig.api.localUrl : AppConfig.api.baseUrl),

  isDevelopment: () => AppConfig.app.environment === "development",
  isProduction: () => AppConfig.app.environment === "production",
};
